import { ProjectForm } from '@/shared/components/projects/ProjectForm'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { requirePermissionBeforeLoad } from '@/shared/lib/authorization/routeAuth'

export const Route = createFileRoute('/projects/new')({
    component: CreateProjectPage,
    beforeLoad: requirePermissionBeforeLoad('view', 'project'),
})

function CreateProjectPage() {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const handleSuccess = async () => {
        if (window.history.length > 2) {
            window.history.back()
        } else {
            await navigate({ to: '/projects' })
        }
    }

    const handleCancel = async () => {
        if (window.history.length > 2) {
            window.history.back()
        } else {
            await navigate({ to: '/projects' })
        }
    }

    return <ProjectForm title={t('projects.create.title')} onSuccess={handleSuccess} onCancel={handleCancel} />
}
